import { render } from "./PortalPage.vue?vue&type=template&id=7f248b79&scoped=true"
import script from "./PortalPage.vue?vue&type=script&lang=js"
export * from "./PortalPage.vue?vue&type=script&lang=js"

import "./PortalPage.vue?vue&type=style&index=0&id=7f248b79&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f248b79"]])

export default __exports__